import clsx from 'clsx';
import { createStyles } from 'game/lib/createStyles';
import { colors, fontWeight, fonts } from 'game/styles/theme';

const classes = createStyles({
  button: {
    fontFamily: fonts.nunito,
    fontSize: '1rem',
    fontWeight: fontWeight.extraBold,
    border: `2px solid ${colors.darkBlue}`,
    borderRadius: 8,
    padding: 10,
    minWidth: 100,
    textTransform: 'uppercase',
    background: colors.accent,
    boxShadow: `2px 2px 0 ${colors.darkBlue}`,
    color: colors.white,
    position: 'relative',

    '&:active': {
      top: 2,
      left: 2,
      boxShadow: 'none',
    },
  },
});

interface UIButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
}

export const UIButton: React.FC<UIButtonProps> = ({ className, ...rest }) => {
  return (
    <button type="button" className={clsx(classes.button, className)} {...rest} />
  );
};
